<template>
    <div class='newsSetting'>
        <tab @getTab="getTab"></tab>
        <div id='content' v-if="status === 'content'">
            <div class='headerSerc-item'>
                <span>{{setTingObj.logoConfig.header}}</span>
                <uploadImage :imageUrl="setTingObj.logoConfig.url" @deleteUrl="deleteLogoUrl" @updateUrl="updateLogoUrl"/>
            </div>
            <div class='headerSerc-item'>
                <span>{{setTingObj.listConfig.title}}</span>
                <newsConfig :setTingObj="setTingObj"></newsConfig>
            </div>
        </div>
        <div id='style' v-if="status ==='style'">
            <div class='headerSerc-item'>
                <span>{{setTingObj.bgStyle.title}} ({{setTingObj.bgStyle.list[setTingObj.bgStyle.type].val}})</span>
                <radio :list="setTingObj.bgStyle.list" :type="setTingObj.bgStyle.type" @change="updateBgStyle"></radio>
            </div>
            <div class='headerSerc-item'>
                <span>{{setTingObj.prConfig.title}}</span>
                <sliderAndInput :lrConfig="setTingObj.prConfig"></sliderAndInput>
            </div>
            <div class='headerSerc-item'>
                <span>{{setTingObj.mbConfig.title}}</span>
                <sliderAndInput :lrConfig="setTingObj.mbConfig"></sliderAndInput>
            </div>
        </div>
    </div>
</template>

<script>
 import tab from '@/components/decoration/common/tab.vue';
 import uploadImage from '@/components/decoration/common/uploadImage.vue'
 import newsConfig from '@/components/decoration/common/newsConfig.vue';
 import sliderAndInput from '@/components/decoration/common/sliderAndInput.vue';
 import color from '@/components/decoration/common/color.vue';
 import radio from '@/components/decoration/common/radio.vue';

 export default {
     components: {
         radio,
         color,
         sliderAndInput,
         tab,
         uploadImage,
         newsConfig,
     },
     data(){
         return {
             status: 'content'
         }
     },
     props: {
         setTingObj: {
             type: Object,
             default: {}
         }
     },
     methods: {
         getTab(e){
             this.status = e
         },
         updateLogoUrl(url){
             this.setTingObj.logoConfig.url = url
         },
         deleteLogoUrl(){
             this.setTingObj.logoConfig.url = ''
         },
         updateBgStyle(type){
             this.setTingObj.bgStyle.type = type
         },
     }
 }
</script>

<style scoped lang="scss">
</style>